import { useState, useEffect } from "react";
import api from "../../utils/api";

// Share of scans still landing on retired (deprecated) codes: a proxy for old packaging still in market
const DeprecatedShareGrid = ({ queryParams }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/api/analytics/deprecated-share?${queryParams}`).then((r) => setRows(r.data)).catch(console.error).finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) return <div className="text-center py-4"><div className="spinner-border spinner-border-sm" role="status" /></div>;
  if (rows.length === 0) return <p className="text-muted text-center mb-0">No scans on retired codes in the selected date range.</p>;

  const num = (n) => n.toLocaleString();
  return (
    <div>
      <p className="text-muted small mb-2">Products whose retired codes are still being scanned in the window. A falling share means old packaging is clearing out.</p>
      <div style={{ maxHeight: "360px", overflow: "auto" }}>
        <table className="table table-sm table-hover" style={{ fontSize: "12px" }}>
          <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
            <tr><th>Item ID</th><th>Product</th><th style={{ textAlign: "right" }}>Retired</th><th style={{ textAlign: "right" }}>Active</th><th style={{ textAlign: "right" }}>Retired share</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.productId}>
                <td style={{ fontFamily: "monospace", whiteSpace: "nowrap" }}>{r.itemId || "—"}</td>
                <td>{r.productName}</td>
                <td style={{ textAlign: "right" }}>{num(r.deprecatedScans)}</td>
                <td style={{ textAlign: "right" }}>{num(r.activeScans)}</td>
                <td style={{ textAlign: "right" }}>
                  <div className="d-flex align-items-center justify-content-end gap-2">
                    <div style={{ width: 60, height: 6, background: "#e9ecef", borderRadius: 3 }}><div style={{ width: `${r.pct}%`, height: 6, background: r.pct >= 50 ? "#dc3545" : "#fd7e14", borderRadius: 3 }} /></div>
                    <span style={{ minWidth: 32, textAlign: "right" }}>{r.pct}%</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeprecatedShareGrid;
